import {appConstants} from '../_constants';
import {initialState} from "../_store";

export function regionalAirlines(state=initialState.regionalAirlines, action) {
  switch (action.type) {
    case appConstants.REGIONAL_AIRLINES_SUCCESS:
      return action.regionalAirlines;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/regional-airline-reducer.js